import { call, put } from '@redux-saga/core/effects';
import { api, notify, apiErrorHandler, applyQueryString } from 'services';
import {
  ListWarehouseVehicleSetupsActions as Actions,
  ListWarehouseVehicleSetupsRequestAction as RequestAction,
} from 'store/ducks/warehouseVehicleSetups';

export function* listWarehouseVehicleSetupsRequest(action: any) {
  const { query = {}, onSuccess, onFailure }: RequestAction = action;
  try {
    const url = applyQueryString('warehouse-vehicle-setups', {
      ...query,
      asList: 1,
      orderBy: 'vehicleTypeName',
      direction: 'asc',
    });
    const { data } = yield call(api.get, url);
    onSuccess && onSuccess();
    yield put(Actions.success(data));
  } catch (error) {
    const { errorMessage } = apiErrorHandler(error);
    onFailure && onFailure();
    notify('error', errorMessage);
    yield put(Actions.failure(errorMessage));
  }
}
